import React from 'react'
import './ProductDetail2.css'
import "../Component/iTiXBix/ITiBizherosection.css"
import "../Component/Gfooter"
import { Link } from 'react-router-dom'
import Gfooter from '../Component/Gfooter'
import BusinessBenefits from '../Component/BusinessBenefits'

const IMAGES = {
  airports: '/GPMS_img/airpotimg.jpg',
  hotels: '/GPMS_img/hotelsandresort.jpg',
  commercial: '/ImagesNew/Hero-Image-LR.png',
  residential: '/GPMS_img/airpotimg.jpg'
}

/* Button links – apne routes ke hisaab se badlo */
const LINKS = {
  demo: '/contact',
  team: '/contact'
}

/* ============================================================
   CONTENT  (client document se – yahin se edit karo)
   ============================================================ */
const HEAD = {
  badge: 'USE CASES',
  title: 'Where Can Global AI Parking System Be Used?',
  subtitle: 'One Intelligent Parking Solution. Multiple Applications.',
  paragraphs: [
    'Global AI Parking System (GPMS) transforms compatible existing CCTV cameras into intelligent vehicle monitoring systems using AI-powered vehicle identification, automatic license plate recognition (ANPR/OCR), and image and video evidence.',
    'Designed for airports, hotels, commercial parking facilities, and private residential societies, GPMS helps organizations improve security, automate vehicle monitoring, reduce revenue leakage, and maintain accurate vehicle movement records.'
  ]
}

const CAPABILITIES = [
  { label: 'AI Vehicle Identification', icon: 'scan' },
  { label: 'ANPR / OCR', icon: 'plate' },
  { label: 'Image & Video Evidence', icon: 'video' }
]

const INDUSTRIES = [
  {
    tag: 'AIRPORTS',
    caption:
      'High-volume vehicle flow, long-term parking, taxi monitoring and revenue verification.',
    image: IMAGES.airports,
    title: 'Airports and Airport Parking Facilities',
    tagline:
      'Smarter Airport Parking. Better Traffic Management. Stronger Revenue Control.',
    intro: [
      'Airports handle thousands of vehicles every day, including private cars, taxis, commercial vehicles, employee vehicles, and long-term parking customers.',
      'Managing high vehicle volumes, monitoring parking duration, and identifying unauthorized parking can be operationally challenging.'
    ],
    helpsTitle: 'How GPMS Helps Airports',
    helps: [
      [
        'Automated vehicle identification',
        'Recognizes vehicles entering and exiting airport parking facilities using AI and license plate OCR.'
      ],
      [
        'Short-term and long-term parking management',
        'Maintains entry-exit records to support parking duration and fee verification.'
      ],
      [
        'Taxi and commercial vehicle monitoring',
        'Helps monitor repeated entries, vehicle movement, and parking activity in designated areas.'
      ],
      [
        'Revenue leakage prevention',
        'Provides independent vehicle records that can be reconciled with parking payment transactions.'
      ],
      [
        'Staff and authorized vehicle management',
        'Supports verification of airport staff, registered operators, and permitted vehicles through connected authorization records.'
      ],
      [
        'Vehicle search and investigation',
        'Helps security teams locate vehicle entry-exit records using registration numbers, timestamps, images, and video evidence.'
      ],
      [
        'Traffic and occupancy insights',
        'Supports vehicle-flow analysis and facility-level occupancy estimates.'
      ]
    ],
    benefits:
      'Faster vehicle verification, stronger revenue assurance, better security oversight, and more efficient airport parking operations.'
  },
  {
    tag: 'HOTELS & RESORTS',
    caption:
      'Guest recognition, valet monitoring, complimentary parking and security.',
    image: IMAGES.hotels,
    title: 'Hotels, Resorts and Hospitality Properties',
    tagline: 'Seamless Guest Parking with Intelligent Vehicle Recognition',
    intro: [
      'Hotels must manage guest vehicles, restaurant visitors, event attendees, valet parking, staff vehicles, and complimentary parking arrangements.',
      'Manual verification can lead to delays, incorrect parking charges, and unauthorized use of parking privileges.'
    ],
    helpsTitle: 'How GPMS Helps Hotels',
    helps: [
      [
        'Guest vehicle recognition',
        'Identifies registered guest vehicles using license plate OCR and connected guest or parking records.'
      ],
      [
        'Contactless parking validation',
        'Supports automated vehicle verification and streamlined entry-exit workflows when integrated with existing access systems.'
      ],
      [
        'Valet vehicle tracking',
        'Maintains entry-exit evidence that supports valet operations and investigations.'
      ],
      [
        'Complimentary parking verification',
        'Helps identify potential misuse of free parking privileges by comparing vehicle records with approved exemptions.'
      ],
      [
        'Visitor and event parking management',
        'Supports monitoring of restaurant guests, conference attendees, and event visitors.'
      ],
      [
        'Improved security',
        'Records vehicle movements and provides images and video evidence for incident investigation.'
      ],
      [
        'Parking duration monitoring',
        'Helps distinguish short visits from overnight or extended parking sessions.'
      ]
    ]
  },
  {
    tag: 'PARKING FACILITIES',
    caption:
      'Vehicle entry-exit monitoring, duration tracking, parking audits and utilization.',
    image: IMAGES.commercial,
    title: 'Commercial and Public Parking Spaces',
    tagline: 'Make Every Parking Entry Accountable',
    intro: [
      'Shopping malls, office buildings, hospitals, commercial complexes, and public parking facilities often manage high vehicle turnover and multiple entry-exit points.',
      'Traditional ticket-based monitoring may create opportunities for missing transactions, incorrect duration calculations, and parking disputes.'
    ],
    helpsTitle: 'How GPMS Helps Parking Operators',
    helps: [
      [
        'Automated entry-exit records',
        'Detects vehicles and creates digital parking movement records.'
      ],
      [
        'License plate-based identification',
        'Reduces dependence on manual number entry and physical parking tickets for vehicle identification.'
      ],
      [
        'Accurate parking duration records',
        'Calculates parking duration from reliably matched entry and exit events.'
      ],
      [
        'Revenue protection',
        'Helps detect discrepancies between observed vehicle activity and recorded parking payments.'
      ],
      [
        'Unauthorized parking monitoring',
        'Supports investigation of overstays, restricted parking, and suspicious vehicle activity.'
      ],
      [
        'Parking utilization insights',
        'Provides entry-exit statistics and occupancy estimates to help operators plan capacity.'
      ],
      [
        'Dispute resolution',
        'Supplies vehicle images, recorded timestamps, and video evidence for verification of parking-related complaints.'
      ],
      [
        'Centralized management',
        'Supports monitoring of multiple parking entry-exit locations through a unified platform.'
      ]
    ],
    benefits:
      'Better parking revenue control, reduced manual workload, improved operational transparency, and a more convenient customer experience.'
  },
  {
    tag: 'PRIVATE SOCIETIES',
    caption:
      'Resident recognition, visitor records, gated access verification and security.',
    image: IMAGES.residential,
    title: 'Private Societies and Gated Residential Communities',
    tagline: 'Intelligent Vehicle Security for Safer Communities',
    intro: [
      'Residential societies and gated communities manage regular movement of residents, guests, delivery vehicles, service providers, and temporary visitors.',
      'Manual security registers and conventional CCTV systems can make visitor verification and historical vehicle searches difficult.'
    ],
    helpsTitle: 'How GPMS Helps Residential Societies',
    helps: [
      [
        'Resident vehicle recognition',
        'Identifies registered resident vehicles using number plate recognition and authorized vehicle databases.'
      ],
      [
        'Visitor vehicle monitoring',
        'Maintains digital entry-exit records with vehicle images, registration details, and recording timestamps.'
      ],
      [
        'Security verification',
        'Helps security personnel identify unknown or unauthorized vehicles for further checking.'
      ],
      [
        'Automated gate integration',
        'Can support access validation and barrier operation through compatible gate-control systems.'
      ],
      [
        'Delivery and service vehicle records',
        'Provides visibility into vehicles entering for deliveries, maintenance, and other services.'
      ],
      [
        'Parking privilege monitoring',
        'Helps investigate unauthorized use of resident or reserved parking where appropriate camera coverage is available.'
      ],
      [
        'Incident investigation',
        'Makes it easier to locate relevant vehicle records and video evidence.'
      ],
      [
        'Centralized security oversight',
        'Supports monitoring of multiple society entrances and exits from one dashboard.'
      ]
    ],
    benefits:
      'Better resident security, improved visitor accountability, reduced manual registers, and more efficient gate monitoring.'
  }
]

const WHY = {
  title: 'Why GPMS Is Suitable for All Four Environments',
  items: [
    {
      icon: 'camera',
      title: 'No Additional Roadside Detection Sensors Required',
      text: 'GPMS works with compatible existing CCTV or IP cameras, reducing the need for additional vehicle-detection hardware.'
    },
    {
      icon: 'scan',
      title: 'AI-Powered Vehicle Identification',
      text: 'Automatically detects vehicles and recognizes supported vehicle categories.'
    },
    {
      icon: 'plate',
      title: 'Automatic License Plate Recognition',
      text: 'Extracts readable registration numbers to support vehicle identification, searching, and verification.'
    },
    {
      icon: 'video',
      title: 'Image and Video Evidence',
      text: 'Maintains visual evidence associated with vehicle movements for security, operational audits, and dispute resolution.'
    },
    {
      icon: 'shield',
      title: 'Revenue and Fraud Monitoring',
      text: 'Supports identification of potential parking revenue discrepancies and unauthorized privileges when integrated with transaction or authorization data.'
    },
    {
      icon: 'dashboard',
      title: 'Centralized Vehicle Monitoring',
      text: 'Provides a common platform for managing vehicle information across multiple supported cameras and locations.'
    }
  ]
}

const CTA = {
  title: 'Transform Your Parking Facility with GPMS',
  subtitle:
    'From Airports to Residential Communities, Every Vehicle Movement Matters.',
  text: 'Global AI Parking System brings intelligent vehicle recognition, visual evidence, and actionable parking insights to different environments using compatible existing camera infrastructure.',
  strap: 'Smarter Parking. Enhanced Security. Better Revenue Protection.',
  primary: 'Request a Demo',
  secondary: 'Contact Our Team',
  tagline: 'GPMS: AI-Powered Parking Intelligence for Every Facility.',
  note: 'Note: Automated barrier control, payment reconciliation, guest or resident authorization, and individual parking-space monitoring require the appropriate integrations or camera coverage. Processing and storage infrastructure is required.'
}

const INDUSTRY_BENEFITS = {
  AIRPORTS: [
    {
      icon: 'bi-gear',
      title: 'Faster vehicle verification'
    },
    {
      icon: 'bi-piggy-bank',
      title: 'Stronger revenue assurance'
    },
    {
      icon: 'bi-shield-check',
      title: 'Better security oversight'
    },
    {
      icon: 'bi-car-front',
      title: 'More efficient airport parking operations'
    }
  ],

  'HOTELS & RESORTS': [
    {
      icon: 'bi-person-check',
      title: 'Better guest experience',
      text: 'Identify registered guest vehicles using compatible number plate recognition and guest records.'
    },
    {
      icon: 'bi-stars',
      title: 'reduced manual verification',
      text: 'Support smoother vehicle verification and reduce manual checks at hotel entrances.'
    },
    {
      icon: 'bi-cash-coin',
      title: 'stronger parking security',
      text: 'Compare vehicle records with approved complimentary parking privileges.'
    },
    {
      icon: 'bi-car-front-fill',
      title: 'improved control over complimentary ',
      text: 'Maintain vehicle movement records to support valet operations and investigations.'
    },
    {
      icon: 'bi-calendar-check',
      title: 'paid parking',
      text: 'Monitor vehicles associated with conferences, weddings, restaurants and special events.'
    }
  ],

  'PARKING FACILITIES': [
    {
      icon: 'bi-receipt',
      title: 'Better parking revenue control',
      text: 'Compare observed vehicle entries and exits with recorded parking payments.'
    },
    {
      icon: 'bi-clock-history',
      title: 'Reduced manual workload',
      text: 'Match entry and exit records to support parking duration and fee verification.'
    },
    {
      icon: 'bi-search',
      title: 'improved operational transparency',
      text: 'Search vehicle records and visual evidence to investigate parking disputes.'
    },
    {
      icon: 'bi-pie-chart',
      title: 'a more convenient customer experience',
      text: 'Use vehicle movement data to understand parking demand and occupancy trends.'
    },
  ],

  'PRIVATE SOCIETIES': [
    {
      icon: 'bi-house-check',
      title: 'Better resident security',
      text: 'Verify registered resident vehicles against connected authorization records.'
    },
    {
      icon: 'bi-person-plus',
      title: 'improved visitor accountability',
      text: 'Maintain vehicle entry and exit records for guests, delivery partners and service providers.'
    },
    {
      icon: 'bi-shield-lock',
      title: 'reduced manual registers',
      text: 'Help security teams investigate unknown vehicles and review available visual evidence.'
    },
    {
      icon: 'bi-car-front',
      title: 'more efficient gate monitoring',
      text: 'Support investigations into unauthorized use of reserved or restricted parking areas.'
    },
  ]
}

/* ============================================================
   ICONS
   ============================================================ */
const ICONS = {
  scan: (
    <>
      <path d='M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2' />
      <circle cx='12' cy='12' r='3' />
    </>
  ),
  plate: (
    <>
      <rect x='2' y='6' width='20' height='12' rx='2' />
      <path d='M6 12h.01M10 12h.01M14 12h4' />
    </>
  ),
  video: (
    <>
      <path d='m16 13 5.22 3.48a.5.5 0 0 0 .78-.42V7.94a.5.5 0 0 0-.78-.42L16 11' />
      <rect x='2' y='6' width='14' height='12' rx='2' />
    </>
  ),
  camera: (
    <>
      <path d='M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z' />
      <circle cx='12' cy='13' r='3' />
    </>
  ),
  shield: (
    <>
      <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
      <path d='m9 12 2 2 4-4' />
    </>
  ),
  dashboard: (
    <>
      <rect x='3' y='3' width='7' height='9' rx='1' />
      <rect x='14' y='3' width='7' height='5' rx='1' />
      <rect x='14' y='12' width='7' height='9' rx='1' />
      <rect x='3' y='16' width='7' height='5' rx='1' />
    </>
  ),
  trend: (
    <>
      <path d='m22 7-8.5 8.5-5-5L2 17' />
      <path d='M16 7h6v6' />
    </>
  )
}

const Icon = ({ name, size = 20 }) => (
  <svg
    viewBox='0 0 24 24'
    width={size}
    height={size}
    fill='none'
    stroke='currentColor'
    strokeWidth='1.8'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    {ICONS[name]}
  </svg>
)

function ProductDetail2 () {
  return (
    <>
      {/* ---------- HERO SECTION ---------- */}
      <div>
        <div className="toll-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="toll-video" autoPlay loop muted playsInline>
          <source src="video/TPMS_video.mp4" type="video/mp4"/>
        </video>
        <div className="toll-overlay">
          <h1 data-aos="fade-up" className='fw-bold text-center transforming'>GLOBAL AI PARKING SYSTEM<br></br><span className='ai-color'>AI-Powered Parking System</span> </h1>
          <p style={{ textAlign: "center" }}>Transforming conventional parking into an intelligent, automated, and data-driven parking ecosystem</p>
          <p className='gradient-col1'>
 Real-Time Monitoring | 100% Transparency | Fraud Prevention | Smart 
Analytics</p>
        </div>
      </div>
    </div>
{/*     
    <section className='iparking-ifile-hero'>
        <video
          className='iparking-ifile-video'
          autoPlay
          loop
          muted
          playsInline
          aria-label='Global AI Parking System background video'
        >
          <source src='video/TMPS_video.MP4' type='video/mp4' />
          Your browser does not support HTML video.
        </video>

        <div className='iparking-ifile-overlay'>
          <h1 className='fw-bold text-center iparking-transforming'>
            GLOBAL AI PARKING SYSTEM
            <br />
            <span className='iparking-ai-color'>AI-Powered Parking System</span>
          </h1>

          <h4>
            Transforming conventional parking into an intelligent, automated,
            and data-driven parking ecosystem
          </h4>

          <p className='iparking-gradient-col'>
            AI Vehicle Recognition | Smart Entry &amp; Exit | Real-Time
            Occupancy | Actionable Insights
          </p>
        </div>
      </section> */}

      <section className='aps-caps'>
        <div className='iparking-hero-top-section'>
          <section className='iparking-hero-section'>
            <div className='iparking-hero-left px-5'>
              <h1 className='iparking-hero-title'>
                <span>Global AI Parking System</span>
              </h1>
              <p className='iparking-hero-desc fw-bold text-justify'>
                GPMS (Global AI Parking System) can be positioned as an
                AI-powered parking and vehicle security solution for airports,
                hotels, commercial parking facilities, and private residential
                societies.
              </p>
              <br />
              <p>
                <b>
                  Each location faces different challenges, so the website
                  should highlight specific problems GPMS solves for that
                  industry, rather than repeating the same features four times.
                </b>
              </p>
              <div className='iparking-hero-buttons'>
                <button className='iparking-hero-demo-btn'>Book Live Demo</button>
                <button className='iparking-hero-video-btn iparking-hero-demo-btn'>
                  Talk to Expert
                </button>
              </div>
            </div>
            <div className='iparking-hero-right'>
              <div className='iparking-hero-image-wrapper'>
                <div className='iparking-hero-image-bg'>
                  <img
                    src='ImagesNew/gpms_hero.jpg'
                    alt='iparking_img'
                    className='iparking-hero-img'
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* ---------- USE CASES SECTION ---------- */}
      <section className='gu'>
        <div className='gu__container'>
          <header className='gu__head'>
            <span className='gu__pill'>{HEAD.badge}</span>

            <h2 className='gu__title'>{HEAD.title}</h2>

            <p className='gu__subtitle'>{HEAD.subtitle}</p>

            <span className='gu__underline' />

            {HEAD.paragraphs.map(p => (
              <p key={p} className='gu__intro'>
                {p}
              </p>
            ))}

            <ul className='gu__caps'>
              {CAPABILITIES.map(c => (
                <li key={c.label}>
                  <Icon name={c.icon} />
                  {c.label}
                </li>
              ))}
            </ul>
          </header>

          {/* ---------- INDUSTRIES ---------- */}
          <div className='gu__industries'>
            {INDUSTRIES.map((u, i) => (
              <article
                className={`gu__ind ${i % 2 ? 'gu__ind--flip' : ''}`}
                key={u.title}
              >
                <div className='gu__ind-top'>
                  <figure className='gu__frame'>
                    <div className='gu__frame-inner'>
                      <span className='gu__tag'>{u.tag}</span>

                      <img
                        src={u.image}
                        alt={u.title}
                        loading='lazy'
                        className='gu__img'
                      />
                    </div>

                    <figcaption>{u.caption}</figcaption>
                  </figure>

                  <div className='gu__ind-text'>
                    <span className='gu__num'>
                      {String(i + 1).padStart(2, '0')}
                    </span>

                    <h3 className='gu__ind-title'>{u.title}</h3>

                    <p className='gu__tagline'>{u.tagline}</p>

                    <span className='gu__card-line' />

                    {u.intro.map(p => (
                      <p key={p} className='gu__para'>
                        {p}
                      </p>
                    ))}
                  </div>
                </div>

                {/* ---------- INDUSTRY FEATURES ---------- */}
                <div className='gu__helps'>
                  <h4 className='gu__helps-title'>{u.helpsTitle}</h4>

                  <ul className='gu__helps-grid'>
                    {u.helps.map(([label, text]) => (
                      <li key={label}>
                        <span className='gu__check' aria-hidden='true'>
                          ✓
                        </span>

                        <div>
                          <strong>{label}</strong>
                          <p>{text}</p>
                        </div>
                      </li>
                    ))}
                  </ul>

                  {/* <div className='gu__benefit'>
                    <span className='gu__benefit-icon'>
                      <Icon name='trend' size={22} />
                    </span>

                    <p>
                      <strong>Business Benefits:</strong> {u.benefits}
                    </p>
                  </div>*/}

                  {/* ---------- INDUSTRY-SPECIFIC BUSINESS BENEFITS ---------- */}
                  <BusinessBenefits
                    title='Business Benefits'
                    subtitle={`Discover how GPMS delivers value for ${u.title} through intelligent vehicle monitoring and parking management.`}
                    items={INDUSTRY_BENEFITS[u.tag] || []}
                  />
                </div>
              </article>
            ))}
          </div>

          {/* ---------- WHY GPMS ---------- */}
          <div className='gu__why'>
            <header className='gu__why-head'>
              <h3>{WHY.title}</h3>
              <span className='gu__underline' />
            </header>

            <div className='gu__why-grid'>
              {WHY.items.map(w => (
                <div className='gu__why-card' key={w.title}>
                  <span className='gu__why-icon'>
                    <Icon name={w.icon} size={24} />
                  </span>

                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ---------- CALL TO ACTION ---------- */}
          <div className='gu__cta'>
            <h3>{CTA.title}</h3>

            <p className='gu__cta-sub'>{CTA.subtitle}</p>

            <p className='gu__cta-text'>{CTA.text}</p>

            <p className='gu__cta-strap'>{CTA.strap}</p>

            <div className='gu__cta-btns'>
              <Link to={LINKS.demo} className='gu__btn gu__btn--solid'>
                {CTA.primary}
              </Link>

              <Link to={LINKS.team} className='gu__btn gu__btn--ghost'>
                {CTA.secondary}
              </Link>
            </div>

            <p className='gu__cta-tag'>{CTA.tagline}</p>
          </div>

          {/* ---------- NOTE ---------- */}
          {/* <p className='gu__note'>{CTA.note}</p> */}
        </div>
      </section>
      <Gfooter/>
    </>
  )
}

export default ProductDetail2